import React from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

import { getTimeZoneOffset } from "../../../../../_metronic/_helpers/GlobalHelpers";

import ReactSelect from "react-select";

var methods = [
  {
    value: true,
    label: "Stripe",
  },
  {
    value: false,
    label: "EMT",
  },
];
const PayAllDrivers = ({
  show,
  setShow,
  setIds,
  ids,
  Names,
  setNames,
  startDate,
  endDate,
  handleGetDrivers,
}) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = JSON.parse(localStorage.getItem("user")).token;
  const [isPaying, setIsPaying] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = React.useState(false);
  const history = useHistory();

  const handlePayAllDrivers = (data) => {
    setIsPaying(true);
    fetch(`${BASE_URL}/Payouts/BulkPayoutMultipleDrivers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
      Allow: "POST",
    })
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          const results = data[1].driverResults;
          const resultsTable = `
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="background: #f3f6f9;">Driver Name</th>
                    <th style="background: #f3f6f9;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  ${results.map(dr => `
                    <tr>
                      <td style="font-weight: 500;">${dr.driverName}</td>
                      <td style="${dr.errorMessage && dr.errorMessage.trim() !== '' ? 'color: #f64e60;' : 'color: #1bc5bd;'}">
                        ${dr.errorMessage && dr.errorMessage.trim() !== '' ? dr.errorMessage : 'Payment processed successfully'}
                      </td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          `;
          
          Swal.fire({
            icon: 'info',
            title: 'Payment Processing Results',
            html: resultsTable,
            width: '800px',
            customClass: {
              container: 'payment-results-modal'
            }
          });
          handleGetDrivers();
          setIds([]);
          setNames([]);
          setShow(false);
        } else if (data[0] === 400 && data[1].message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data[1].message,
          });
        } else if (data[0] === 400) {
          let tt = JSON.parse(data[1]);
          for (const [key, value] of Object.entries(tt.errors)) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: value,
            });
          }
        } else if (data[0] === 401) {
          history.push("/logout");
        } else if (data[0] === 402) {
          Swal.fire({
            title: "Info!",
            text: "You have to subscribe first!",
            icon: "info",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/user-profile");
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsPaying(false);
      });
  };
  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Pay All Drivers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h6 className="font-weight-bold mb-3">Drivers to be Paid:</h6>
                <div className="row">
                  {Names &&
                    Names.map((el, index) => (
                      <div className="col-md-4 mb-2" key={index}>
                        <span className="badge badge-light p-2">{el.name}</span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h6 className="font-weight-bold mb-4">
                  Select Payment Method:
                </h6>
                <div className="row">
                  <div className="col-12">
                    <ReactSelect
                      className="basic-single w-100"
                      classNamePrefix="select"
                      isSearchable={true}
                      options={methods}
                      value={methods.find((el) => el.value === paymentMethod)}
                      onChange={(e) => {
                        setPaymentMethod(e.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row">
          <div className="col-12 text-right">
            <button className="btn btn-light" onClick={() => setShow(false)}>
              Cancel
            </button>
            {!paymentMethod && (
              <button
                className="btn btn-warning ml-2"
                onClick={() => {
                  const data = {
                    driverIds: ids,
                    payByStripe: false,
                    manual: true,
                    timezone: getTimeZoneOffset(),
                    startDate: startDate,
                    endDate: endDate,
                  };
                  handlePayAllDrivers(data);
                }}
                disabled={isPaying}
              >
                {isPaying ? "Processing..." : "Pay Manually"}
              </button>
            )}
            <button
              className="btn btn-info ml-2"
              onClick={() => {
                const data = {
                  driverIds: ids,
                  payByStripe: paymentMethod,
                  manual: false,
                  timezone: getTimeZoneOffset(),
                  startDate: startDate,
                  endDate: endDate,
                };
                handlePayAllDrivers(data);
              }}
              disabled={isPaying}
            >
              {isPaying ? "Processing..." : "Pay Bill"}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PayAllDrivers;
